<template src="./TerapiasPaciente.html"></template>

<script>
import { patientTherapies } from "../mocks";
import TarjetaPaciente from "../TarjetaPaciente/TarjetaPaciente";
import ClusterPacientes from "../ClusterPacientes/ClusterPaciente";
import {
  crearFormulario,
  consultarInformacionGeneralPaciente,
} from "../../../apiService/request/CrudFormulario";
import { consultarEstructuraCuestionarioPorId } from "../../../apiService/request/CrudSeguimiento";
import {
  leerLista,
  createThertapyPatient,
  readTherapyPatient,
  readSchemes,
  cancelTherapyPatient,
  verificarplanDeAccion,
  generatePdf
} from "../../../apiService/request/CrudTerapias";
import Mensajes from "../../Mensajes/Mensajes";
export default {
  data() {
    return {
      cedulaPaciente: null,
      clusterSelected: null,
      therapySelected: null,
      patientTherapies: [],
      variablesInforGeneral: [],
      dialog: false,
      therapiesItems: [],
      schemesItems: [],
      reglaObligatorioTherapy: [(v) => !!v || "Selecciona una terapia"],
      reglaObligatorioScheme: [(v) => !!v || "Selecciona una plantilla"],
      addValid: false,
      docIdToCancel: null,
      clusterPaciente: false,
      ClusterData: {},
      virtualTherapies: [],
      virtualTherapiesSelected: "",
      priceLevel: [],
      priceLevelSelected: "",
      seeBtnActionPlan: false,
      createUrl: false,
      generatedUrl: '',
      dialog2: false,
    };
  },
  created() {
    this.$parent.$emit("navContent", 0);
    this.clusterPaciente = false;
  },
  methods: {
    async  generatePdfPlanAction() {
      try {
        this.$store.dispatch("setCargando", true);
        const response  = await generatePdf(
          parseInt(this.cedulaPaciente)
        )
        if (response && response.data && response.data.data) {
          this.generatedUrl  = response.data.data.url;
          this.seeBtnActionPlan = false;
        }
      } catch (error) {
        console.log(error);
      }
      finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async consultarplanDeAccion() {
      try {
        const response = await verificarplanDeAccion(
          this.cedulaPaciente
        )
        if(response && response.data && response.data.data) this.createUrl = response.data.data.crear_pdf;
        this.seeBtnActionPlan = this.createUrl;
      } catch (error) {
        console.log(error);
      }
    },
    resetForm() {
      this.$refs.formAdd.reset();
      this.schemesItems = [];
      this.therapiesItems = [];
      this.virtualTherapies = [];
      this.virtualTherapiesSelected = "";
      this.priceLevel = [];
      this.priceLevelSelected = "";
      this.dialog = false;
    },
    async searchPatient() {
      try {
        this.$store.dispatch("setCargando", true);
        this.clusterPaciente = false;
        this.ClusterData = {};
        const respuesta = await consultarInformacionGeneralPaciente(
          this.cedulaPaciente,
          "informacion_general",
          null
        );
        if (respuesta && respuesta.data && respuesta.data.data) {
          console.log("respuesta", respuesta);
          this.variablesInforGeneral = respuesta.data.data.variables;
          await this.consultarplanDeAccion();
        } else {
          this.variablesInforGeneral = [];
          alert(
            `El paciente con el documento ${this.cedulaPaciente} no fue encontrado.`
          );
        }
        this.$store.dispatch("setCargando", false);
      } catch (error) {
        console.log(error);
      } finally {
        await this.searchPatientTherapies();
      }
    },
    async searchPatientTherapies() {
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await readTherapyPatient(this.cedulaPaciente);
        if (respuesta && respuesta.data && respuesta.data.data) {
          console.log(respuesta);
          this.patientTherapies = respuesta.data.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async getSchemesItems() {
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await readSchemes(this.therapySelected);
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.schemesItems = respuesta.data.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async addSchemeToPatient() {
      if (this.$refs.formAdd.validate()) {
        try {
          this.$store.dispatch("setCargando", true);
          const respuesta = await createThertapyPatient(
            this.priceLevelSelected,
            this.virtualTherapiesSelected,
            this.clusterSelected.docId,
            this.therapySelected,
            this.clusterSelected.nombre_esquema,
            this.cedulaPaciente,
            this.$store.state.provider_email
          );
          if (respuesta.status === 409) {
            if (respuesta && respuesta.data && respuesta.data.data) {
              const dialogoModal = {
                dialogo: true,
                mensaje: `El paciente ya cuenta con una terapia '${this.therapySelected}', ¿desea cancelarla y asignarle la nueva plantilla?`,
                opciones: ["Si", "No"],
                status: 200,
              };
              this.docIdToCancel = respuesta.data.data.docId;
              this.$store.dispatch("cambiarEstadoModal", true);
              this.$store.dispatch("cambiarMensajeModal", dialogoModal);
            }
          } else if (respuesta.status === 201 || respuesta.status === 200) {
            this.docIdToCancel = null;
            if (respuesta && respuesta.data && respuesta.data.data) {
              this.resetForm();
              await this.searchPatientTherapies();
            }
          }
        } catch (err) {
          console.log(err);
        } finally {
          this.$store.dispatch("setCargando", false);
        }
      }
    },
    datosCluster(
      therapyName,
      docId,
      clusterName,
      stateCluster,
      priceLevel,
      service
    ) {
      this.ClusterData = {
        docId,
        therapyName,
        clusterName,
        documentPatient: this.cedulaPaciente,
        stateCluster,
        priceLevel,
        service,
      };
      // console.log(this.ClusterData);
      // this.TeraphyName = therapyName;
      this.clusterPaciente = true;
    },
  },
  props: ["valorSeleccionadoDialogo"],
  watch: {
    async dialog(newValue) {
      if (newValue === true) {
        try {
          this.$store.dispatch("setCargando", true);
          const respuesta = await leerLista("terapias_planb");
          if (respuesta && respuesta.data && respuesta.data.data) {
            this.therapiesItems = respuesta.data.data;
            const respuesta2 = await leerLista("terapias_virtuales");
            if (respuesta2 && respuesta2.data && respuesta2.data.data) {
              this.virtualTherapies = respuesta2.data.data;
            }
            const respuesta3 = await leerLista("nivel_de_precio");
            if (respuesta3 && respuesta3.data && respuesta3.data.data) {
              this.priceLevel = respuesta3.data.data;
            }
          }
        } catch (err) {
          console.log(err);
        } finally {
          this.$store.dispatch("setCargando", false);
        }
      }
    },
    async valorSeleccionadoDialogo(newValue) {
      if (newValue === "Si") {
        try {
          const respuesta = await cancelTherapyPatient(
            this.docIdToCancel,
            this.cedulaPaciente,
            this.$store.state.provider_email
          );
          if (respuesta && respuesta.data && respuesta.data.data) {
            await this.addSchemeToPatient();
          }
        } catch (err) {
          console.log("error:cancelando", err);
        } finally {
        }
      }
    },
  },
  components: {
    TarjetaPaciente,
    ClusterPacientes,
    Mensajes,
  },
};
</script>

<style src="./TerapiasPaciente.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Terapias/TerapiasPaciente/TerapiasPaciente.vue